import { SET_VISIBILITY, SET_DOWNLOADING_VISIBILITY } from "./actionTypes";

/** Set loader visibility */
export const setLoaderVisibility = isLoading => dispatch => {
	dispatch({
		type: SET_VISIBILITY,
		payload: isLoading
	});
};

/** Set downloader visibility */
export const setDownloaderVisibility = isLoading => dispatch => {
	dispatch({
		type: SET_DOWNLOADING_VISIBILITY,
		payload: isLoading
	});
};
